import { FocusEvent, FunctionComponent, useState } from 'react';
import { MarkdownInput } from '@starjack/shared-components';

type MarkdownInputProps = {
    name?: string;
    label: string;
    value: string;
    onBlur: (nextVal: string, e: FocusEvent<HTMLInputElement>) => void;
    sx?: Record<string, unknown>;
};

export const MarkdownInputFormWrapper: FunctionComponent<
    MarkdownInputProps
> = ({ name, label, value, onBlur }) => {
    const [internalValue, setInternalValue] = useState(value);
    const [oldValue, setOldValue] = useState(value);

    if (value !== oldValue) {
        setOldValue(value);
        setInternalValue(value);
    }

    const onChange = (nextValue: string) => {
        setInternalValue(nextValue);
    };

    return (
        <>
            <MarkdownInput
                label={label}
                value={internalValue}
                onChange={onChange}
                name={name}
                onBlur={onBlur}
                excludeCommands={['image']}
            />
        </>
    );
};
